export default __webpack_public_path__ + "static/media/speakers__chris-eidhof.aa4ce135.jpg";